import React from 'react';

import {observer} from 'mobx-react';
import {OddsTooltip} from "../../tooltip/odds-tooltip";
import {GameCardOddsCellContent} from "./game-card.odds-cell-content";
import styles from "./game-card-odds-cell.module.scss";
import classnames from "classnames";
import {useBookieClick} from "../../../../../infrastructure/hooks/useBookieClick";
import {APP} from "../../../../app/consts";
import {PartialGameViewModel} from "../../../../../domain/partial-game/models/partial-game-view-model";
import {ALL_SCORES} from "../../../../../widgets/all-scores-widget/all-scores-widget-consts";
import {Link} from "../../../link/link";
import {LINK_REL} from "../../../../consts";

export const GameCardOddsCell = observer(({
                                            game,
                                            source,
                                            option,
                                            controller,
                                            betsImpressionParams,
                                            disableTooltip,
                                            cellClassName,
                                            highlightOdds,
                                            showOriginalOdds
                                          }) => {
  const {odds, isEnded} = game;
  const {state} = controller;
  const {currentLinkModel, appSettings} = state;

  const {bookieHrefModel, onBookieClick} = useBookieClick(controller, {
    urlLink: appSettings.publisherSettings?.bookmakerUrl || odds.rateOptions[option.num - 1].link || odds.bookmaker.link,
    entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[PartialGameViewModel.name],
    entityId: game.id,
    status: game.statusGroup,
    currentLinkModelName: currentLinkModel?.name,
    marketType: odds.lineTypeId,
    bookieId: odds.bookmaker.id,
    bookieName: odds.bookmaker.name,
    actualBetOdd: odds.rateOptions[option.num - 1].currentRate,
    buttonType: APP.ANALYTICS.BUTTON_TYPES_MAPPER[odds.rateOptions.length][option.num],
    clickType: ALL_SCORES.ANALYTICS.BOOKIE_CLICK_TYPES.bookie,
    impressionType: APP.ANALYTICS.BETS_IMPRESSION_TYPES.odds,
    hasOdds: true,
    source
  });

  const canClickBookie = !!(bookieHrefModel && onBookieClick) && !odds.bookmaker.isDummyBookie;

  const tooltipProps = {
    disable: disableTooltip,
    bookmaker: odds.bookmaker,
    option,
    controller,
    bookieHrefModel,
    betsImpressionParams,
    showOriginalOdds,
    onClick: canClickBookie ? () => onBookieClick() : undefined,
    className: classnames(styles.container, cellClassName, {
      [styles.cell_ended]: isEnded && !option.isWon,
      [styles.cell_won]: option.isWon,
      [styles.cell_highlight]: highlightOdds
    })
  };

  const linkProps = {
    model: bookieHrefModel,
    rel: LINK_REL.SPONSORED_NOOPENER,
    onClick: canClickBookie ? (e) => {
      e.stopPropagation();

      return onBookieClick();
    } : undefined,
    className: classnames(styles.container, cellClassName, {
      [styles.cell_ended]: isEnded && !option.isWon,
      [styles.cell_won]: option.isWon,
      [styles.cell_highlight]: highlightOdds
    })
  }

  const rateProps = {
    option,
    controller,
    betsImpressionParams,
    onBookieClick,
    bookieHrefModel
  }

  return (
    <OddsTooltip {...tooltipProps}>
      <Link {...linkProps}>
        <GameCardOddsCellContent {...rateProps}/>
      </Link>
    </OddsTooltip>
  )
});
